/**
 * Web shim for @react-native-firebase/app
 */

const firebaseApp = {
  app: () => ({
    options: {
      projectId: 'web',
      messagingSenderId: 'web',
      appId: 'web',
    },
  }),
};

export default firebaseApp;
export const firebase = firebaseApp;
